import React from "react";
import type { StepRenderProps } from "@/components/onboarding/components/WelcomeWizard/WelcomeWizard.types";
import {
  FooterButton,
  FooterContainer,
  StepContent,
  StepTitle,
  WizardContentWrapper,
} from "@/components/onboarding/components/WelcomeWizard/WelcomeWizard.styles";
import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";
import styled from "@emotion/styled";
import { APP_CONFIG } from "@/domains/global/config";

export const IntroVideoStep: React.FC<StepRenderProps> = ({ onClose }) => {
  const handleDone = (event?: React.MouseEvent) => {
    // Complete the onboarding flow
    event?.preventDefault();
    event?.stopPropagation();
    onClose?.();
  };

  return (
    <WizardContentWrapper style={{ height: "460px" }}>
      <StepTitle>Get started with Mem in 5 minutes</StepTitle>

      <StepContent>
        <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
          Learn how to make the most of your new AI thought partner
        </MDSText>

        <StyledVideoWrapper>
          <StyledVideoIframe
            src={APP_CONFIG.URLS.INTRO_VIDEO_EMBED_URL}
            title="Welcome to Mem - Your AI Thought Partner"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </StyledVideoWrapper>
      </StepContent>

      <FooterContainer>
        <FooterButton onClick={handleDone}>Finish</FooterButton>
      </FooterContainer>
    </WizardContentWrapper>
  );
};

const StyledVideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledVideoIframe = styled.iframe`
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  height: 315px;
  width: 560px;
`;
